{
	"domain-codes": {
		"activeEvaluationMeasureType": {
			"ISOLATION": {
				"abbreviation": "ISO",
				"display": "Actieve isolatiemaatregelen"
			},
			"RESTRICTION": {
				"abbreviation": "VBM",
				"display": "Actieve vrijheidsbeperkende maatregelen"
			}
		},
		"assessmentStatus": {
			"NOT_PLANNED": {
				"display": "Niet gepland"
			},
			"OPEN": {
				"display": "Open {{relativeTime}}"
			},
			"PLANNED": {
				"display": "Gepland {{date}}"
			},
			"TODAY": {
				"display": "Vandaag"
			}
		},
		"boolean": {
			"FALSE": {
				"display": "Nee"
			},
			"TRUE": {
				"display": "Ja"
			}
		},
		"evaluationMeasureStatus": {
			"ACTIVE": {
				"display": "Actief"
			},
			"NEW": {
				"display": "Nieuw"
			},
			"STOPPED": {
				"display": "Gestopt"
			}
		},
		"followUpEvaluationMeasureStatus": {
			"ALTERNATIVE_ACTIVE": {
				"display": "Alternatieve maatregelen behouden"
			},
			"ALTERNATIVE_MODIFIED": {
				"display": "Alternatieve maatregelen wijzigen"
			},
			"ALTERNATIVE_NEW": {
				"display": "Alternatieve maatregelen starten"
			},
			"ALTERNATIVE_NONE": {
				"display": "Geen alternatieve maatregelen starten"
			},
			"ALTERNATIVE_STOPPED": {
				"display": "Alternatieve maatregelen stopzetten"
			},
			"ISOLATION_ACTIVE": {
				"display": "Isolatiemaatregelen behouden"
			},
			"ISOLATION_MODIFIED": {
				"display": "Isolatiemaatregelen wijzigen"
			},
			"ISOLATION_NEW": {
				"display": "Isolatiemaatregelen starten"
			},
			"ISOLATION_NONE": {
				"display": "Geen Isolatiemaatregelen starten"
			},
			"ISOLATION_STOPPED": {
				"display": "Isolatiemaatregelen stopzetten"
			},
			"NO_MEASURES": {
				"display": "Geen maatregelen"
			},
			"RESTRICTION_ACTIVE": {
				"display": "Restrictieve maatregelen behouden"
			},
			"RESTRICTION_MODIFIED": {
				"display": "Restrictieve maatregelen wijzigen"
			},
			"RESTRICTION_NEW": {
				"display": "Restrictieve maatregelen starten"
			},
			"RESTRICTION_NONE": {
				"display": "Geen restrictieve maatregelen starten"
			},
			"RESTRICTION_STOPPED": {
				"display": "Restrictieve maatregelen stopzetten"
			},
			"UNKNOWN_MEASURES": {
				"display": "Onbekende maatregelen"
			}
		},
		"followUpPlanStatus": {
			"CLOSED": {
				"display": "Gesloten {{date}}"
			},
			"NOT_PLANNED": {
				"display": "Opvolging in te plannen"
			},
			"OVERDUE": {
				"display": "Opvolging {{relativeTime}}"
			},
			"PLANNED": {
				"display": "Opvolging {{date}}"
			},
			"TODAY": {
				"display": "Opvolging vandaag"
			}
		}
	}
}
